<template>
  <div class="TabacProfilagePatientReport">
    <img src="/tabac/tabac-vignette-rapport.png" style="width: 100%; margin-bottom: 20px"/>

    <div style="color: black">
      <div style="font-size: 25px">Rapport profilage adhérent | <b>{{ report.data.patient.first_name }} {{ report.data.patient.last_name }}</b></div>
      <hr class="mb-1"/>
    </div>

    <div class="my-12">
      <h2>Quel genre de fumeur êtes-vous ?</h2>
      <hr class="mb-1"/>
      <div v-if="report.data.quel_genre !== null">
        <h3 class="my-3">Sexe : <b v-if="report.data.quel_genre.sexe === 0">Homme</b><b v-else>Femme</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.sexe === 1">Êtes-vous enceinte : <b v-if="report.data.quel_genre.enceinte === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.sexe === 1">Êtes-vous sous pilule contraceptive : <b v-if="report.data.quel_genre.pillule === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">Âge : <b>{{report.data.quel_genre.age}}</b></h3>
        <h3 class="my-3">Taille (en cm) : <b>{{report.data.quel_genre.taille}}</b></h3>
        <h3 class="my-3">Poids (en kg) : <b>{{report.data.quel_genre.poids}}</b></h3>
        <h3 class="my-3">Avez-vous subi des variations importantes de poids dans votre vie : {{report.data.quel_genre.variation}}</h3>
        <h3 class="my-3" v-if="report.data.quel_genre.variation === 1">À quelle occasion : <b>{{report.data.quel_genre.occasion}}</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.variation === 1">En quelle année : <b>{{report.data.quel_genre.annee}}</b></h3>
        <h3 class="mt-3">Maladies et traitements associés : </h3>
        <ul class="mb-3">
          <li v-if="report.data.quel_genre.cholesterol && report.data.quel_genre.cholesterol.checked">Cholestérol</li>
          <li v-if="report.data.quel_genre.diabete && report.data.quel_genre.diabete.checked">Diabète</li>
          <li v-if="report.data.quel_genre.triglycerides && report.data.quel_genre.triglycerides.checked">Triglycérides</li>
          <li v-if="report.data.quel_genre.hypertension && report.data.quel_genre.hypertension.checked">Hypertension</li>
          <li v-if="report.data.quel_genre.cardio && report.data.quel_genre.cardio.checked">Problèmes cardio-vasculaires</li>
          <li v-if="report.data.quel_genre.pulmonaire && report.data.quel_genre.pulmonaire.checked">Problèmes pulmonaires</li>
          <li v-if="((report.data.quel_genre.cholesterol && report.data.quel_genre.cholesterol.checked) || (report.data.quel_genre.diabete && report.data.quel_genre.diabete.checked) || (report.data.quel_genre.triglycerides && report.data.quel_genre.triglycerides.checked) || (report.data.quel_genre.hypertension && report.data.quel_genre.hypertension.checked) || (report.data.quel_genre.cardio && report.data.quel_genre.cardio.checked) || (report.data.quel_genre.pulmonaire && report.data.quel_genre.pulmonaire.checked)) === false">Aucune</li>
        </ul>
        <h3 class="my-3">Prenez-vous des médicaments ou des traitements au long cours : <b v-if="report.data.quel_genre.longCours">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.longCours === 0"> : <b>{{report.data.quel_genre.longCoursLequels}}</b></h3>
        <h3 class="my-3">Éprouvez-vous des difficultés professionnelles ou personnelles actuellement : <b>{{report.data.quel_genre.difficultesPerso}}</b></h3>
        <h3 class="mt-3">Événement antérieur notable :</h3>
        <ul class="mb-3">
          <li v-if="report.data.quel_genre.traumatisme && report.data.quel_genre.traumatisme.checked">Traumatisme</li>
          <li v-if="report.data.quel_genre.phobie && report.data.quel_genre.phobie.checked">Phobie</li>
          <li v-if="(report.data.quel_genre.traumatisme && report.data.quel_genre.traumatisme.checked || report.data.quel_genre.phobie && report.data.quel_genre.phobie.checked) === false">Aucun</li>
        </ul>
        <h3 class="mt-3">Prenez-vous :</h3>
        <ul class="mb-3">
          <li v-if="report.data.quel_genre.tranquillisants && report.data.quel_genre.tranquillisants.checked">Des tranquillisants</li>
          <li v-if="report.data.quel_genre.antidepresseurs && report.data.quel_genre.antidepresseurs.checked">Des antidépresseurs</li>
          <li v-if="report.data.quel_genre.substitutifs && report.data.quel_genre.substitutifs.checked">Des traitements substitutifs</li>
          <li v-if="(report.data.quel_genre.tranquillisants && report.data.quel_genre.tranquillisants.checked || report.data.quel_genre.antidepresseurs && report.data.quel_genre.antidepresseurs.checked || report.data.quel_genre.substitutifs && report.data.quel_genre.substitutifs.checked) === false">Rien</li>
        </ul>
        <h3 class="my-3">Combien de verres d’alcool buvez-vous/jour : <b>{{report.data.quel_genre.verreAlcool}} verres(s)</b></h3>
        <h3 class="my-3">Autres addictions : <b v-if="report.data.quel_genre.autre === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.autre === 0">Lesquelles : <b>{{report.data.quel_genre.autreLequelles}}</b></h3>
        <h3 class="my-3" v-if="report.data.quel_genre.autre === 0">Combien de fois par jour : <b>{{report.data.quel_genre.autreCombien}} fois</b></h3>
        <h3 class="my-3">Y-a-t-il d’autres fumeurs dans le foyer : <b v-if="report.data.quel_genre.autresFumeurs === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">Fumez-vous dans l’habitat ou dans la voiture : <b v-if="report.data.quel_genre.fumerVoiture === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">Fumez-vous dans l’habitat ou dans la voiture : <b v-if="report.data.quel_genre.fumerVoiture === 0">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">Activité physique hebdomadaire : <b v-if="report.data.quel_genre.apHebdo === 0">30mn</b><b v-else-if="report.data.quel_genre.apHebdo === 1">1 / 2h</b><b v-else-if="report.data.quel_genre.apHebdo === 2">3 / 4h</b><b v-else>plus de 4h</b></h3>

      </div>
      <div v-else>
        L'adhérent n'a pas encore rempli cette mission.
      </div>
    </div>

    <div class="my-12">
      <h2>Test de Fagerström</h2>
      <hr class="mb-1"/>
      <div v-if="report.data.fagerstrom !== null">
        <h3 class="my-3">Le matin, combien de temps après être réveillé(e), fumez-vous votre première cigarette : <b v-if="report.data.quel_genre.cigaretteMatin === 3">Dans les 5 minutes</b><b v-else-if="report.data.quel_genre.cigaretteMatin === 2">6 à 30 minutes</b><b v-else-if="report.data.quel_genre.cigaretteMatin === 1">31 à 60 minutes</b><b v-else>Plus de 60 minutes</b></h3>
        <h3 class="my-3">Trouvez-vous qu'il est difficile de vous abstenir de fumer dans les endroits où c'est interdit (ex: cinéma, bibliothèque) : <b v-if="report.data.quel_genre.interdit === 1">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">À quelle cigarette renoncierez-vous le plus difficilement : <b v-if="report.data.quel_genre.renoncer === 1">La première de la journée</b><b v-else>Une autre</b></h3>
        <h3 class="my-3">Combien de cigarettes fumez-vous par jour, en moyenne : <b>{{report.data.fagerstrom.combien}}</b></h3>
        <h3 class="my-3">Fumez-vous à intervalles plus rapprochés durant les premières heures de la matinée que durant le reste de la journée : <b v-if="report.data.quel_genre.interval === 1">Oui</b><b v-else>Non</b></h3>
        <h3 class="my-3">Fumez-vous lorsque vous êtes malade au point de devoir rester au lit presque toute la journée : <b v-if="report.data.quel_genre.malade === 1">Oui</b><b v-else>Non</b></h3>
      </div>
      <div v-else>
        L'adhérent n'a pas encore rempli cette mission.
      </div>
    </div>

    <div class="my-12">
      <h2>Test de Horn</h2>
      <hr class="mb-1"/>
      <div v-if="report.data.horn !== null">
        <h3 class="my-3">Stimulation : <b>{{report.data.horn.coupFouet + report.data.horn.courage + report.data.horn.imposer}}</b></h3>
        <h3 class="my-3">Plaisir du geste : <b>{{report.data.horn.plaisirFumer + report.data.horn.plaisirManipuler + report.data.horn.plaisirVolutes}}</b></h3>
        <h3 class="my-3">Relaxation : <b>{{report.data.horn.relaxant + report.data.horn.plaisirActeFumer + report.data.horn.fumerDetendu}}</b></h3>
        <h3 class="my-3">Anxiété-Soutien : <b>{{report.data.horn.soucieux + report.data.horn.malAise + report.data.horn.fumerCafard}}</b></h3>
        <h3 class="my-3">Besoin absolu : <b>{{report.data.horn.courirAcheter + report.data.horn.fumePas + report.data.horn.besoinManipuler}}</b></h3>
        <h3 class="my-3">Habitude acquise : <b>{{report.data.horn.automatisme + report.data.horn.allumerAutre + report.data.horn.oublierBouche}}</b></h3>
      </div>
      <div v-else>
        L'adhérent n'a pas encore rempli cette mission.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import api from 'api'
import moment from 'moment'
import MissionHeaderBlock from 'components/blocks/MissionHeaderBlock'
import ParagraphBlock from 'components/blocks/ParagraphBlock'
import SubHeaderBlock from 'components/blocks/SubHeaderBlock'


export default {
  components: {
  },

  data() {
    return {

    }
  },

  computed: {

  },

  methods: {

  },

  mounted() {

  },

  props: {
    report: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss"
       type="text/scss">
.TabacProfilagePatientReport {
  font-size: 16px;

  .BlocQR {
    margin-bottom: 25px;
  }

  .Reponse {
    font-weight: bold;
    margin-left: 10px;
  }

  .Question {
  }

  .imgSlot {
    position: relative;
    margin-bottom: 20px;
  }

  .thumbnail {
    width: 153px;
    height: 224px;
  }

  .fullSize {
    object-fit: scale-down;
    min-width: 54vh;
    height: 96vh;
    width: auto;
    margin: 0px 5px;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}
</style>
